<template>
  <div>
    <AdminBriefOverview>
      <template #header>
        <div class="mb-6">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <h1 class="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight text-gray-900">
                {{ t("greeting", { name: currentUser.firstName || "" }) }}
              </h1>
              <div class="text-sm text-gray-400 mt-1">{{ $d(new Date(), "fullDate") }}</div>
            </div>
            <div class="flex flex-col sm:flex-row gap-2">
              <GenericButton v-if="hasActiveChallenge" @click="$router.push('/admin/challenge/current-challenge')">
                {{ t("challenge") }}
              </GenericButton>
              <SecondaryButton @click="$router.push('/admin/analytics/general')">
                <ChartBarIcon class="h-4 w-4 mr-2" />
                {{ t("global_view") }}
              </SecondaryButton>
            </div>
          </div>
        </div>
      </template>
    </AdminBriefOverview>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { SecondaryButton, GenericButton } from "@estaly/ui";
import { ChartBarIcon } from "@heroicons/vue/outline";
import AdminBriefOverview from "@/views/common/AdminBriefOverview.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    SecondaryButton,
    GenericButton,
    ChartBarIcon,
    AdminBriefOverview,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),
    ...mapGetters("challenge", ["hasActiveChallenge"]),
  },
};
</script>

<i18n src="./AdminBriefHome.i18n.json"></i18n>
